import React from 'react';

export const BookingConfirmation = ({
  service,
  date,
  timeSlot,
  error,
  onConfirm,
  onBack,
  isLoading,
  policyAgreed,
  onPolicyAgreedChange,
  onShowPolicy
}) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h2 className="text-xl font-semibold text-gray-900">אשר את פרטי התור</h2>
      </div>

      <div className="bg-white/50 rounded-2xl p-4 space-y-3">
        <div className="flex justify-between">
          <span className="text-gray-600">שירות:</span>
          <span className="font-semibold">{service?.name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">תאריך:</span>
          <span className="font-semibold">
            {date &&
              new Date(date).toLocaleDateString('he-IL', {
                weekday: 'long',
                month: 'long',
                day: 'numeric'
              })}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">שעה:</span>
          <span className="font-semibold">{timeSlot?.time}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">מטפל:</span>
          <span className="font-semibold">{timeSlot?.crewMemberName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">משך:</span>
          <span className="font-semibold">{service?.duration} דקות</span>
        </div>
        {service?.show_price_to_customers ? (
          <div className="flex items-center gap-3 pt-2 border-t border-gray-200">
            <span className="text-gray-600">מחיר:</span>
            <span className="text-lg font-semibold text-rose-600">₪{service?.price}</span>
          </div>
        ) : (
          <div className="pt-2 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              <span className="font-medium">מחיר:</span> יימסר בעת הטיפול
            </p>
          </div>
        )}
      </div>

      {/* Policy Agreement Checkbox */}
      <div className="bg-gray-50 rounded-2xl p-4">
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={policyAgreed}
            onChange={(e) => onPolicyAgreedChange(e.target.checked)}
            className="mt-1 w-5 h-5 text-rose-500 border-gray-300 rounded focus:ring-rose-500 cursor-pointer"
          />
          <span className="text-gray-700 text-sm leading-relaxed">
            אני מסכים/ה ל
            <button
              type="button"
              onClick={onShowPolicy}
              className="text-rose-500 hover:text-rose-600 underline font-medium mx-1"
            >
              מדיניות ביטולים ושינויים
            </button>
          </span>
        </label>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-2xl p-4">
          <p className="text-red-600 text-sm text-center">{error}</p>
        </div>
      )}

      <div className="flex gap-3">
        <button
          onClick={onBack}
          className="flex-1 py-3 border border-gray-300 rounded-2xl font-semibold text-gray-700 hover:bg-gray-50"
        >
          חזור
        </button>
        <button
          onClick={onConfirm}
          disabled={isLoading || !policyAgreed}
          className="flex-1 bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'קובע תור...' : 'אשר וקבע תור'}
        </button>
      </div>
    </div>
  );
};
